import { render, staticRenderFns } from "./MRCV3SubmissionFields.vue?vue&type=template&id=4c5bf494"
import script from "./MRCV3SubmissionFields.vue?vue&type=script&lang=js"
export * from "./MRCV3SubmissionFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports